(function () {
  var STATES = {
    CMX: 'Ciudad de México', MEX: 'Estado de México', JAL: 'Jalisco', ROO: 'Quintana Roo', VER: 'Veracruz',
    GUA: 'Guanajuato', CHP: 'Chiapas', PUE: 'Puebla', NLE: 'Nuevo León', YUC: 'Yucatán', SIN: 'Sinaloa',
    BCS: 'Baja California Sur', GRO: 'Guerrero', TAB: 'Tabasco', MIC: 'Michoacán', QUE: 'Querétaro',
    MOR: 'Morelos', COA: 'Coahuila', SLP: 'San Luis Potosí', ZAC: 'Zacatecas', CAM: 'Campeche',
    HID: 'Hidalgo', COL: 'Colima', AGU: 'Aguascalientes', DUR: 'Durango', NAY: 'Nayarit',
    CHH: 'Chihuahua', SON: 'Sonora', TLA: 'Tlaxcala', TAM: 'Tamaulipas'
  };

  var script = document.currentScript;
  var shopUrl = (script && script.getAttribute('data-shop-url')) || window.location.origin;
  var pageUrl = (script && script.getAttribute('data-page-url')) || window.location.href;

  function titleCase(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/(^|[\s,.\-/])([a-zà-ÿ])/g, function (match, separator, letter) {
        return separator + letter.toUpperCase();
      })
      .replace(/(^|[\s,])(De|Del|La|Las|Los|El|Y|En)(?=[\s,]|$)/g, function (match, separator, word, offset) {
        return offset === 0 ? match : separator + word.toLowerCase();
      })
      .replace(/(^|[\s,])Cdmx(?=[\s,]|$)/g, '$1CDMX')
      .trim();
  }

  function phoneToE164(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 10) return '+52' + digits;
    if (digits.length === 12 && digits.indexOf('52') === 0) return '+' + digits;
    return '';
  }

  function build(stores) {
    var items = [];

    stores.forEach(function (store) {
      if (!store || store.storeCode === 'CAMPUS' || !store.lat || !store.lng) return;

      var node = {
        '@type': 'ClothingStore',
        '@id': pageUrl + '#store-' + store.storeCode,
        name: 'Shasa ' + titleCase(store.name),
        url: pageUrl,
        branchOf: { '@id': shopUrl + '#organization' },
        address: {
          '@type': 'PostalAddress',
          streetAddress: [store.address, store.addressTwo].filter(Boolean).join(', '),
          addressLocality: titleCase(store.municipio || store.ciudad),
          addressRegion: STATES[store.estado] || store.estado,
          postalCode: String(store.zipCode || '').padStart(5, '0'),
          addressCountry: 'MX'
        },
        geo: { '@type': 'GeoCoordinates', latitude: store.lat, longitude: store.lng }
      };

      var phone = phoneToE164(store.phone);
      if (phone) node.telephone = phone;

      items.push(node);
    });

    return items;
  }

  function inject() {
    if (document.querySelector('script[data-store-schema]')) return true;
    if (!Array.isArray(window.shasaStores) || !window.shasaStores.length) return false;

    var graph = build(window.shasaStores);
    if (!graph.length) return true;

    var tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.setAttribute('data-store-schema', '');
    tag.text = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
    document.head.appendChild(tag);
    return true;
  }

  if (!inject()) {
    window.addEventListener('load', inject);
  }
})();
